import { StorefrontModule } from '@vue-storefront/core/lib/modules';
import { matrixratesModule } from './store'

export const MatrixratesModule: StorefrontModule = async function ({ app, store, router, moduleConfig, appConfig }) {
  store.registerModule('matrixrates', matrixratesModule)
}
